module.exports = __webpack_public_path__ + "static/media/Logo_AHC_Indonesia_(1).fb8123e3.png";